import React, { useState } from "react";
import { IDetailsReportEditionContextProps, IEditionEventDetails } from "./DetailsReportEditionContextInterface";
import { DetailsReportEditionContext, initialState } from "./DetailsReportEditionContext";

export const DetailsReportEditionProvider: React.FC<IDetailsReportEditionContextProps> = ({ children }) => {
    const [edit, setEdit] = useState<IEditionEventDetails[]>(initialState.edit);

    const providerValue = {
        edit,
        setEdit,
    };

    return (
        <DetailsReportEditionContext.Provider value={providerValue}>{children}</DetailsReportEditionContext.Provider>
    );
};
